// implementa una funcion exportable
// que sea un caso de uso recibiendo un repositorio

export function getOnboardingReview(onboardingReviewRepository) {
  // implementa la logica de negocio
  return onboardingReviewRepository.get();
}
